<template>
  <v-card>
    <v-form>
      <v-card-text>
        <v-flex>
          <v-text-field
            label="Insert Choice here..."
            v-model="label"
            required
          ></v-text-field>
        </v-flex>
      </v-card-text>
      <v-card-text>
        <v-flex>
          <v-text-field
            label="Points"
            v-model="value"
            required
          ></v-text-field>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          @click="submit"
        >Submit</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import axios from 'axios'
import config from '../../../../../configApi'
const apiUrl = config.apiUrl

export default {
  data () {
    return {
      label: null,
      value: null
    }
  },
  methods: {
    submit () {
      this.insertChoice(this.selectedQuestionId)
    },
    insertChoice (questionId) {
      var formData = new FormData()
      formData.append('questionnaire_id', questionId)
      formData.append('label', this.label)
      formData.append('value', this.value)

      axios.post(apiUrl + '/choices', formData).then((res) => {
        console.log(res.data)
      })
    }
  },
  props: {
    apiUrl: String,
    selectedQuestionId: Number
  }
}
</script>


// WEBPACK FOOTER //
// src/components/admin/module/question/addChoiceForm.vue